// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__2q90s","marginWrapper":"Page_marginWrapper__6osxm","body":"Page_body__3v2Fh","header":"Page_header__KPL2s","headerDivider":"Page_headerDivider__2ox88"};